import React from 'react';

interface OnboardingSubtitleProps {
  text: string;
}

export default function OnboardingSubtitle({ text }: OnboardingSubtitleProps) {
  return <p className='text-sm text-gray-600'>{text}</p>;
}
